import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

const Testimonial = () => {
    return (
        <section className="section testimonials">
            <div className="section-header">
                <div className="label">Client Stories</div>
                <h2>What Our Clients Say</h2>
                <p>
                    Building lasting partnerships through exceptional service and results
                </p>
            </div>

            <Swiper
                modules={[Pagination, Autoplay]}
                spaceBetween={30}
                slidesPerView={1}
                pagination={{ clickable: true }}
                autoplay={{ delay: 3000 }}
                breakpoints={{
                    768: { slidesPerView: 2 },
                    1024: { slidesPerView: 3 },
                }}
            >
                {/* Slide 1 */}
                <SwiperSlide>
                    <div className="testimonial-card">
                        <div className="testimonial-text">
                            "Greenbucks transformed our outdated system into a modern,
                            cloud-based solution. Their team's expertise and dedication
                            exceeded our expectations."
                        </div>
                        <div className="testimonial-author">
                            <div className="author-avatar">RS</div>
                            <div className="author-info">
                                <h4>Rajesh Sharma</h4>
                                <p>CTO, TechFlow Solutions</p>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>

                {/* Slide 2 */}
                <SwiperSlide>
                    <div className="testimonial-card">
                        <div className="testimonial-text">
                            "The React Native app they built is fast, beautiful, and exactly
                            what we needed. Delivered on time and within budget."
                        </div>
                        <div className="testimonial-author">
                            <div className="author-avatar">PM</div>
                            <div className="author-info">
                                <h4>Priya Mehta</h4>
                                <p>Product Manager, StartupHub</p>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>

                {/* Slide 3 */}
                <SwiperSlide>
                    <div className="testimonial-card">
                        <div className="testimonial-text">
                            "Their staffing solution was perfect. The engineers integrated
                            seamlessly and brought exactly the expertise we needed."
                        </div>
                        <div className="testimonial-author">
                            <div className="author-avatar">AK</div>
                            <div className="author-info">
                                <h4>Amit Kumar</h4>
                                <p>Engineering Director, InnovateCorp</p>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="testimonial-card">
                        <div className="testimonial-text">
                            "Their staffing solution was perfect. The engineers integrated
                            seamlessly and brought exactly the expertise we needed."
                        </div>
                        <div className="testimonial-author">
                            <div className="author-avatar">AK</div>
                            <div className="author-info">
                                <h4>Amit Kumar</h4>
                                <p>Engineering Director, InnovateCorp</p>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="testimonial-card">
                        <div className="testimonial-text">
                            "Their staffing solution was perfect. The engineers integrated
                            seamlessly and brought exactly the expertise we needed."
                        </div>
                        <div className="testimonial-author">
                            <div className="author-avatar">AK</div>
                            <div className="author-info">
                                <h4>Amit Kumar</h4>
                                <p>Engineering Director, InnovateCorp</p>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>

            </Swiper>
        </section>
    );
};

export default Testimonial;